import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import useAlert from '../../../Alerts/useAlert';
import usePrivileges from '../../../Auth/usePrivileges';

import CommentDialog from "../../../Dialogs/CommentDialog";

interface ResendProductWriteOnButtonProps {
    setLoading: Dispatch<SetStateAction<boolean>>
}

function ResendProductWriteOnButton({ setLoading }: ResendProductWriteOnButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();

    const { lotDetail: {
        summary: {
            lotNumber,
            businessUnitCode,
            shouldSendProductWriteOn
        }
    } } = useContext(LotDetailContext);
    const { supervisor, admin } = usePrivileges(businessUnitCode);

    const [showCommentDialog, setShowCommentDialog] = useState<boolean>(false);

    const handleSendProductWriteOnSample = async (comment: string) => {
        setLoading(true);
        await fetchDataAuthenticated(`api/v1/lot/${lotNumber}/sendProductWriteOn`, 'POST', JSON.stringify(comment))
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", "Product write on successfully sent");
                } else {
                    let errorMessage = await response.text();
                    throw new Error("Failed to resend the product write on: " + errorMessage);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Button variant="primary"
                onClick={() => setShowCommentDialog(true)}
                disabled={!supervisor && !admin}
                hidden={!shouldSendProductWriteOn}>
                {t('LotDetails.Summary.ResendProductWriteOn')}
            </Button>
            <CommentDialog
                showDialog={showCommentDialog}
                closeDialog={() => setShowCommentDialog(false)}
                onSave={handleSendProductWriteOnSample} />
        </>
    );
}

export default ResendProductWriteOnButton;